import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import DatePickerInput from "../../../share/input/DatePicker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import { ReactComponent as Upload } from "../../../../Assets/Image/svg/Upload.svg";
import { Modal } from "../../../share/modal/Modal";
import { BsArrowLeft } from "react-icons/bs";
import DragAndDrop from "../../../share/dragAndDropFile/DragAndDrop";
import { Link } from "react-router-dom";
import useFetch from "../../../../Hooks/useFetch";
import MessageQuill from "../../Message/MessageQuill";
import moment from "jalali-moment";
import { useCreate } from "../../../../Context/CreateContext";
import * as yup from "yup";

const schema = yup.object().shape({
  bootcamp_name: yup.string().required("نام بوت کمپ را وارد کنید"),
  bootcamp_category: yup.string().required("دسته بندی بوت کمپ را وارد کنید"),
});

const CourseGeneralInfo = (props) => {
  //Context
  const { phaseStatus, setPhaseStatus, bootCamp, setBootCamp } = useCreate();

  const [upload, setUpload] = useState(false);
  const [file, setFile] = useState("");
  const [categories, setCategories] = useState();

  const [bootcampStart, setBootcampStart] = useState("");
  const [bootcampEnd, setBootcampEnd] = useState("");
  const [bootcampDescription, setBootcampDescription] = useState("");

  useEffect(() => {
    setGeneralInfoData({
      ...generalInfoData,
      bootcamp_start_time: moment(
        bootcampStart,
        "HH:mm:ss jYYYY/jMM/jDD"
      ).format(),
    });
  }, [bootcampStart]);

  useEffect(() => {
    setGeneralInfoData({
      ...generalInfoData,
      bootcamp_end_time: moment(bootcampEnd, "HH:mm:ss jYYYY/jMM/jDD").format(),
    });
  }, [bootcampEnd]);

  useEffect(() => {
    setGeneralInfoData({
      ...generalInfoData,
      bootcamp_description: bootcampDescription,
    });
  }, [bootcampDescription]);

  useEffect(() => {
    setGeneralInfoData({
      ...generalInfoData,
      bootcamp_cover: file[0],
    });
  }, [file]);

  const [generalInfoData, setGeneralInfoData] = useState({
    bootcamp_name: "",
    category: "",
    bootcamp_start_time: "",
    bootcamp_end_time: "",
    bootcamp_description: "",
    bootcamp_cover: "",
  });

  // const [generalInfoData2, setGeneralInfoData2] = useState({
  //     bootcamp_name: "",
  //     category: "",
  //     bootcamp_start_time: "",
  //     bootcamp_end_time: "",
  //     bootcamp_description: "",
  //     bootcamp_cover: "",
  // });

  const [call, setCall] = useState();

  const getCategories = useFetch({
    method: "GET",
    url: "BootCampService/bootcamp_categories",
    noHeader: false,
    trigger: true,
    setter: setCategories,
  });

  const getGeneralInfo = useFetch({
    method: "GET",
    url: `BootCampService/${bootCamp?.id}`,
    noHeader: false,
    trigger: false,
    setter: setGeneralInfoData,
  });

  const postGeneralInfo = useFetch({
    method: "POST",
    url: "BootCampService",
    noHeader: false,
    trigger: false,
    data: call,
    caller: getGeneralInfo,
    setter: setBootCamp,
  });

  const editGeneralInfo = useFetch({
    method: "PUT",
    url: `BootCampService/${bootCamp?.id}`,
    noHeader: false,
    data: call,
    trigger: false,
    caller: getGeneralInfo,
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setGeneralInfoData({
      ...generalInfoData,
      [name]: value,
    });
  };

  const submitForm = () => {
    const formData = new FormData();

    formData.append("category", generalInfoData.category);
    formData.append("bootcamp_name", generalInfoData.bootcamp_name);
    formData.append("bootcamp_start_time", generalInfoData.bootcamp_start_time);
    formData.append("bootcamp_end_time", generalInfoData.bootcamp_end_time);
    formData.append(
      "bootcamp_description",
      generalInfoData.bootcamp_description
    );
    formData.append("bootcamp_cover", generalInfoData.bootcamp_cover);

    setCall(formData);
    postGeneralInfo.reFetch();
  };

  useEffect(() => {
    if (postGeneralInfo.status === 201) {
      props.nextStep();
      console.log("Next Step");
      setPhaseStatus({ ...phaseStatus, general: true });
      console.log(phaseStatus);
    }
  }, [postGeneralInfo.status]);

  useEffect(() => {
    phaseStatus.general && getGeneralInfo.reFetch();
  }, [phaseStatus]);

  //TODO : inja dar in lahze Mahdi pare shod ta in dorost shod :))
  useEffect(() => {
    if (phaseStatus.general && getGeneralInfo.status === 200) {
      setBootcampStart(
        moment(generalInfoData.bootcamp_start_time)
          .locale("fa", { useGregorianParser: true })
          .format("HH:mm:ss YYYY/MM/DD")
      );
      setBootcampEnd(
        moment(generalInfoData.bootcamp_end_time)
          .locale("fa", { useGregorianParser: true })
          .format("HH:mm:ss YYYY/MM/DD")
      );
    }
  }, [generalInfoData]);
  //TODO

  const handleModal = () => {
    setUpload((perv) => !perv);
  };

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({ validationSchema: schema });

  return (
    <div>
      <h3 className="text-[#77498F] font-bold text-[20px] text-center my-8">
        اطلاعات کلی بوت کمپ
      </h3>
      <form onSubmit={handleSubmit(submitForm)}>
        <input
          {...register("bootcamp_name")}
          type="text"
          name="bootcamp_name"
          control={control}
          value={generalInfoData.bootcamp_name}
          onChange={handleInputChange}
          placeholder="نام بوت کمپ *"
          className="border-gray input h-[6.4rem] w-full bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] mb-[1.6rem]"
        />

        <select
          {...register("bootcamp_category")}
          type="text"
          name="category"
          onChange={handleInputChange}
          value={generalInfoData.category}
          control={control}
          placeholder="برگزار کننده"
          className={`border-gray input h-[6.4rem] w-full ${
            generalInfoData.category ? "text-black" : "text-[#21212199]"
          } bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] mb-[1.6rem]`}
        >
          <option value="" disabled selected>
            دسته‌ بندی *
          </option>

          {categories?.results.map((category) => {
            return (
              <option key={category.id} value={category.id}>
                {category.category_name}
              </option>
            );
          })}
        </select>

        <div className="grid grid-cols-2 gap-[40px] mb-8">
          <DatePickerInput
            setDate={setBootcampStart}
            message="تاریخ شروع بوت‌کمپ"
            placeholder="تاریخ شروع بوت‌کمپ *"
            name="bootcamp_start_time"
            control={control}
            defaultValue={bootcampStart}
            plugins={[<TimePicker position="bottom" />]}
          />
          <DatePickerInput
            setDate={setBootcampEnd}
            message="تاریخ پایان بوت‌کمپ"
            placeholder="تاریخ پایان بوت‌کمپ *"
            name="bootcamp_end_time"
            control={control}
            defaultValue={bootcampEnd}
            plugins={[<TimePicker position="bottom" />]}
          />
        </div>
        <MessageQuill
          setValue={setBootcampDescription}
          value={generalInfoData.bootcamp_description}
          placeholder="توضیحات کلی *"
        />
        <div
          className=" w-1/2 py-[20px] px-[25px] flex border-gray border-[1px] text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] justify-between cursor-pointer"
          onClick={() => setUpload(!upload)}
        >
          <span>بارگزاری بنر</span>
          <Upload />
        </div>
        <div className="flex justify-between items-center mt-20">
          <Link
            to="/dashboard"
            className="w-[20%] py-[15px] px-[35px] flex text-purple-dark text-[1.8rem] rounded-[1.5rem] justify-around items-center cursor-pointer"
          >
            انصراف
          </Link>
          <button
            className="w-[20%] py-[15px] px-[35px] flex border-purple-dark text-purple-dark border-[1px] text-[1.8rem] rounded-[1.5rem] justify-around items-center cursor-pointer"
            type="submit"
          >
            <span>ثبت و ادامه</span>
            <BsArrowLeft />
          </button>
        </div>
      </form>

      <Modal show={upload} closeModal={handleModal}>
        <DragAndDrop
          bootcamp_cover={generalInfoData?.bootcamp_cover}
          setFile={setFile}
          close={handleModal}
          label=""
          {...register("photo", { required: false })}
          //message="رزومه خود را انتخاب کنید"
          error={errors["photo"]}
          accept=".png , .jpg"
          //id="cover_upload"
          type="image"
        />
      </Modal>
    </div>
  );
};

export default CourseGeneralInfo;
